import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { LocationAcl } from '@era/locations-sdk';

export type LocationAclState = EntityState<LocationAcl>;

export function selectAclIdFromResourceId(locationAcl: LocationAcl) {
  return locationAcl.resourceId;
}

export const adapter: EntityAdapter<LocationAcl> = createEntityAdapter<LocationAcl>({
  selectId: selectAclIdFromResourceId,
});

export const initialState: LocationAclState = adapter.getInitialState();
